/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { AccountsDirectory } from "./AccountsDirectory";
import { CLIENT_ROLES } from "../api/accounts";
import { useChrome } from "../contexts/ChromeContext";

export function Families() {
  useChrome({}, []);
  return (
    <div className="space-y-8">
      <header className="enter">
        <h1 className="font-display text-2xl leading-tight text-text-primary sm:text-[1.75rem]">
          Families
        </h1>
        <p className="mt-2 text-[15px] leading-relaxed text-text-secondary">
          The families receiving care. A child&apos;s Healthie id finds the whole family.
        </p>
      </header>
      <AccountsDirectory
        scope="clients"
        roleOptions={[...CLIENT_ROLES]}
        searchPlaceholder="Search by name, email, phone, Healthie id, or id"
      />
    </div>
  );
}
